export default __webpack_public_path__ + "static/media/OpenSans-Semibold.029b9bc9.ttf";